import React, { useState, useEffect } from "react";
import * as S from "./styles";

import perfil from "../../assets/profile_def.png";
import { LogoutBtn } from "../Buttons";
import { useWindowDimension } from "../../shared/utils/CustomHooks";
import { useSelector } from "react-redux";
import { IState } from "../../app-state/reducer";
import { Customer, Session } from "../../models";
import { CustomerService } from "../../services";

export default function ProfileAvatar(credits?: number, base64?: string) {
    return (
        <>
            <S.Profile>
                <img src={base64 ? base64 : perfil} alt="avatar" />
                <span style={{color: credits !== 0 ? "#0dadea" : "ef3c34"}}>Creditos: {credits}</span>
            </S.Profile>
        </>
    );
}

export const ProfileAndExit: React.FC = () => {
    const customer = useSelector<IState, Customer | undefined>(
        (state) => state.customer
    );
    const session = useSelector<IState, Session | undefined>(
        (state) => state.session
    );
    const dimensions = useWindowDimension();
    const [credits, setCredits] = useState<number>();

    const fetchCredits = async () => {
        const sr = await CustomerService.My();
        setCredits(sr.status() ? sr.data.currentBalance : 0);
    };

    useEffect(() => {
        if (!customer) {
            fetchCredits();
        }
    }, [customer]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: dimensions.width <= 768 ? "baseline" : "center",
                flexDirection: dimensions.width <= 768 ? "column" : "row",
                alignSelf: dimensions.width <= 768 ? "baseline" : undefined,
                paddingLeft: dimensions.width <= 768 ? "10px" : undefined,
            }}
        >
            {ProfileAvatar(
                customer?.currentBalance || credits,
                session?.profilePicture
            )}
            <LogoutBtn style={{ margin: "1vw" }} />
        </div>
    );
};
